import { Injectable } from '@angular/core';
import { of, Observable, map, concatMap, take, iif } from 'rxjs';
import { ErrorService } from '../../../../../../core/services/error.service';
import { HttpStudentService } from '../../../../../../core/services/http/http-student.service';
import {
  AbstractUpdateComponentStore,
  UpdateState,
  updateInitialState,
} from '../../../../../../core/state/base-component-stores/abstract-update.component-store';
import { StudentResult } from '../../../../../../shared/models/api-results/student.api-result';
import { Student } from '../../../../../../shared/models/entities/student.entity';
import {
  StudentUniversityFormValue,
  StudentUniversityPayload,
} from '../../../../../../shared/models/payloads/student.payload';
import { HttpUserService } from '../../../../../../core/services/http/http-user.service';
import {
  UserAddressAndInformationsFormValue,
  UserAddressPayload,
  UserInformationsPayload,
  UserIsActivePayload,
  UserIsLockedPayload,
} from '../../../../../../shared/models/payloads/user.payload';
import { tapResponse } from '@ngrx/component-store';
import {
  ApiError,
  convertHttpErrorToApiError,
} from '../../../../../../shared/models/api-results/error.api-result';
import { EcniUser } from '../../../../../../shared/models/entities/ecni-user.entity';
import {
  CallState,
  LoadingState,
  getCallStateError,
} from '../../../../../../shared/models/interfaces/call-state.interface';
import { WGenericUserUpdateStoreService } from '../../../writer-shared/users/stores/w-generic-user-update.component-store';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { ComponentAdminType } from '../../../../../../shared/models/enums/interface.enums';
import * as AuthSelectors from '../../../../../../core/state/auth-state/auth.selectors';

@Injectable()
export class WStudentUpdateStoreService extends WGenericUserUpdateStoreService {
  constructor(
    httpUserService: HttpUserService,
    errorService: ErrorService,
    toastr: ToastrService,
    store: Store,
    private httpStudentService: HttpStudentService
  ) {
    super(store, httpUserService, toastr, errorService);
  }

  // SELECTORS

  entity$ = this.select((state) =>
    state.entity ? new Student(state.entity as StudentResult) : undefined
  );

  // EFFECTS

  getApiCall(id: string) {
    return this.componentType$.pipe(
      take(1),
      concatMap((componentType) =>
        iif(
          () => componentType === ComponentAdminType.ADMIN,
          this.httpStudentService.wGet(id),
          this.store.select(AuthSelectors.loggedStudent).pipe(take(1))
        )
      )
    );
  }

  updateApiCall(
    id: string,
    formValue: Partial<StudentUniversityFormValue>
  ): Observable<Partial<StudentResult>> {
    return this.httpStudentService
      .wUpdateStudentUniversity(id, new StudentUniversityPayload(formValue))
      .pipe(
        map(() => {
          return Student.studentUpdatedEntityToResult(formValue);
        })
      );
  }
}
